export const serviceFieldLabels = {
  'languages.english': 'English',
  'languages.french': 'French',
  'languages.spanish': 'Spanish',

  'customer_convenience.waiting_area_available': 'Waiting Area Available',
  'customer_convenience.child_friendly_waiting_rm': 'Separate Child Play Area',
  'customer_convenience.financing_available': 'Financing Available',
  'customer_convenience.overnight_key_drop': 'Offers Overnight Key Drop',
  'customer_convenience.customer_pickup_drop_off': 'Customer Pick-Up / Drop-Off Service Offered',
  'customer_convenience.loaner_vehicles': 'Offers Loaner Vehicles',

  'mechanical_services.air_conditioning': 'Air Conditioning',
  'mechanical_services.battery': 'Battery',
  'mechanical_services.belts_and_hoses': 'Belts and Hoses',
  'mechanical_services.complete_brake_service': 'Complete Brake Service',
  'mechanical_services.front_end_axle_cv_repair': 'Front End/Axle/CV Repair',
  'mechanical_services.oil_filter_lube': 'Oil, Filter and Lube',
  'mechanical_services.major_mech_repair': 'Major Mechanical Repair',
  'mechanical_services.service_electric_cars': 'Service Electric Vehicles',
  'mechanical_services.state_inspection': 'State Inspection',
  'mechanical_services.shocks_and_struts': 'Shocks and Struts',

  'ers_services.roadside_service': 'Roadside Service',
  'ers_services.roadside_service_24_hrs': 'Roadside Service 24hrs',
  'ers_services.towing_service': 'Towing',
  'ers_services.towing_service_24_hrs': 'Towing 24hrs',

  'programs.processes_national_accounts': 'Processes National Accounts',
  'programs.rec_offroad_specialist': 'Rec Off-Road Specialist',
  'programs.uhp_specialist': 'Ultra High Performance Specialist',
  'programs.nafa_urban_participant': 'NAFA Urban Participant',
  'programs.mounted_wheel_service': 'Mounted Wheel Service',
  'programs.loose_tire_pickup': 'Loose Tire Pickup',
  'programs.michelin_national_account': 'Michelin National Account',
  'programs.autointegrate': 'Auto Integrate',

  'tire_services.all_wheel_alignment': 'All Wheel Alignment',
  'tire_services.computer_balancing': 'Computer Balancing',
  'tire_services.custom_wheel_sales': 'Custom Wheel Sales',
  'tire_services.farm_tire_service': 'Farm Tire Service',
  'tire_services.tire_installation_service': 'Tire Installation Service',
  'tire_services.rv_tire_sales': 'RV Tire Sales',
  'tire_services.service_and_mount_hp_tires': 'Service and Mount High Performance Tires',
  'tire_services.service_and_mount_std_tires': 'Service and Mount Standard Tires',
  'tire_services.service_run_flat_tires': 'Service Run-Flat Tires',
  'tire_services.service_tpms': 'Service Tire Pressure Monitoring Systems',
  'tire_services.tire_inflation_with_nitrogen': 'Tire Inflation with Nitrogen',
  'tire_services.tire_repairs': 'Tire Repairs',
  'tire_services.winter_tire_studding': 'Winter Tire Studding',
  'tire_services.wheel_sales': 'Wheel Sales',

  'vehicle_types_serviced.passenger_lt': 'Passenger / Light Truck',
  'vehicle_types_serviced.light_commercial': 'Light Commercial',
  'vehicle_types_serviced.medium_commercial': 'Medium Commercial',
  'vehicle_types_serviced.heavy_commercial': 'Heavy Commercial',

  'protections_and_warranties.road_hazard_protection': 'Road Hazard Protection',
  'protections_and_warranties.tire_warranty': 'Tire Warranty',

  all_brands: 'Services all brands',
  brands: 'Car Brands Serviced',
};

const servicesFields = {
  // customerConvenience
  waiting_area_available: 'Waiting Area Available',
  child_friendly_waiting_rm: 'Separate Child Play Area',
  financing_available: 'Financing Available',
  overnight_key_drop: 'Offers Overnight Key Drop',
  customer_pickup_drop_off: 'Customer Pick-Up / Drop-Off Service Offered',
  loaner_vehicles: 'Offers Loaner Vehicles',

  // tireAndRelatedServices
  all_wheel_alignment: 'All Wheel Alignment',
  computer_balancing: 'Computer Balancing',
  custom_wheel_sales: 'Custom Wheel Sales',
  farm_tire_service: 'Farm Tire Service',
  tire_installation_service: 'Tire Installation Service',
  rv_tire_sales: 'RV Tire Sales',
  service_and_mount_hp_tires: 'Service and Mount High Performance Tires',
  service_and_mount_std_tires: 'Service and Mount Standard Tires',
  service_run_flat_tires: 'Service Run-Flat Tires',
  service_tpms: 'Service Tire Pressure Monitoring Systems',
  tire_inflation_with_nitrogen: 'Tire Inflation with Nitrogen',
  tire_repairs: 'Tire Repairs',
  winter_tire_studding: 'Winter Tire Studding',
  wheel_sales: 'Wheel Sales',

  // MechanicalServices
  air_conditioning: 'Air Conditioning',
  battery: 'Battery',
  belts_and_hoses: 'Belts and Hoses',
  complete_brake_service: 'Complete Brake Service',
  front_end_axle_cv_repair: 'Front End/Axle/CV Repair',
  oil_filter_lube: 'Oil, Filter and Lube',
  major_mech_repair: 'Major Mechanical Repair',
  service_electric_cars: 'Service Electric Vehicles',
  state_inspection: 'State Inspection',
  shocks_and_struts: 'Shocks and Struts',
  roadside_service: 'Roadside Service',
  roadside_service_24_hrs: 'Roadside Service 24hrs',
  towing_service: 'Towing',
  towing_service_24_hrs: 'Towing 24hrs',

  // CarBrands
  all_brands: 'Services all brands',
  car_brands: 'Car Brands Serviced',

  // Languages
  english: 'English',
  french: 'French',
  spanish: 'Spanish',

  // Tire Warranties
  road_hazard_protection: 'Road Hazard Protection',
  tire_warranty: 'Tire Warranty On',

  // Programs / National Accounts
  processes_national_accounts: 'Processes National Accounts',
  rec_offroad_specialist: 'Rec Off-Road Specialist',
  uhp_specialist: 'Ultra High Performance Specialist',
  nafa_urban_participant: 'NAFA Urban Participant',

  // Urban Participant Services
  mounted_wheel_service: 'Mounted Wheel Service',
  loose_tire_pickup: 'Loose Tire Pickup',

  // Processes National Accounts
  michelin_national_account: 'Michelin National Account',
  autointegrate: 'AutoIntegrate',

  // Vehicle Types Serviced
  passenger_lt: 'Passenger / Light Truck',
  light_commercial: 'Light Commercial',
  medium_commercial: 'Medium Commercial',
  heavy_commercial: 'Heavy Commercial',
} as any;

export function serviceFieldLabel(field:string, countryCode:string):string {
  if (countryCode === 'ca') {
    if (field === 'state_inspection') return 'Province Inspection';
  }
  return servicesFields[field];
}
